import Vue from 'vue';
import Router from 'vue-router';
import {checkLogin, getDistributorErpConfig} from '@/utils/user';
import {webDataCollectionFn, showPageInitFailureModal, isInterceptorHandled, resetInterceptorHandled, isChunkLoadError} from '@/utils/common'
import store from '@/store/store';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/login',
    component: () => import('@/views/shopping/login/commom/main'), // 引入主文件
    children: [
      {
        path: '/login', // 商城--登录
        component: () => import('@/views/shopping/login/components/login')
      },
      {
        path: '/register', // 商城--注册
        component: () => import('@/views/shopping/login/components/register')
      },
      {
        path: '/password', // 商城--找回密码
        component: () => import('@/views/shopping/login/components/password')
      }
    ]
  },
  {
    path: '/logout', // 商城--登出
    component: () => import('@/views/shopping/login/components/logout')
  },
  {
    path: '/supplierSettlement', // 商城--供应商入驻
    component: () => import('@/views/shopping/login/components/supplierSettlement')
  }
];
const router = new Router({
  mode: 'hash',
  routes
});

/**
 * 统一处理商城登录页初始化失败场景。
 * @param {Function} next vue-router 导航回调。
 * @param {Error} error 当前初始化异常。
 */
const handlePageInitFailure = (next, error) => {
  console.error('router beforeEach error:', error);
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  next(false);
  if (isInterceptorHandled) {
    resetInterceptorHandled();
    return;
  }
  showPageInitFailureModal();
}

router.beforeEach(async (to, from, next) => {
  try {
    if (window.location.href.includes('from=listing')) {
      store.commit('fromListing', true);
    }
    webDataCollectionFn();
    if (to.path === '/login') {
      await checkLogin();
      return next();
    }
    if (to.path !== '/supplierSettlement') {
      const erpConfig = await getDistributorErpConfig(false);
      if (erpConfig === false) {
        throw new Error('getDistributorErpConfig failed');
      }
      return next();
    }
    next();
  } catch (e) {
    handlePageInitFailure(next, e);
  }
});
// 路由错误处理
router.onError((error) => {
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  console.error('router error:', error);
});

export default router;
